module.exports = __webpack_public_path__ + "img/partner_img2.fdacc56a.png";